import Api from "../../../Api";
import { useTranslation } from "react-i18next";
import UpdateBookingsRequest from "../requests/UpdateBookingsRequest";
import { updateValueWithId } from "../../../lib/PlannerUtils";
import { useBookingsStore, useDateStore } from "../../../stores/planner";
import { shallow } from "zustand/shallow";
import TeambookDialog from "../../default_components/TeambookDialog";
import PropTypes from "prop-types";

const RepetitionEditQuestionDialog = ({
  open,
  setRepetitionQuestionDialogOpened,
  setBookings,
  closeEditWindow,
  editingData,
  setProjects,
  plannerDispatcher,
  projects,
  filteredUsers,
}) => {
  const { t } = useTranslation();

  const [date] = useDateStore((state) => [state.date], shallow);
  const [bookings] = useBookingsStore((state) => [state.bookings], shallow);

  const getAllIndexes = (arr, userId) => {
    let indexes = [];
    arr.forEach((user, i) => {
      if (user.id === userId) {
        indexes.push(i);
      }
    });

    return indexes;
  };

  const handleClose = () => {
    setRepetitionQuestionDialogOpened(false);
  };

  const handleNo = () => {
    updateRepBookings(false);
  };

  const handleYes = () => {
    updateRepBookings(true);
  };

  const updateRepBookings = (alsoRep) => {
    UpdateBookingsRequest(
      editingData.projectId,
      editingData.duration,
      editingData.tentative,
      editingData.location,
      editingData.startTime,
      editingData.comment,
      editingData.bookingsToUpdate,
      bookings,
      setBookings,
      closeEditWindow,
      alsoRep,
      editingData.usesBudget,
      editingData.task_id,
      editingData.repetition,
      date
    ).then((response) => {
      let projectIds = [editingData.projectId];
      let bookingsToUpdate = editingData.bookingsToUpdate
        .map((booking) => getAllIndexes(filteredUsers, booking.user_id))
        .flat();

      if (editingData.repetition) {
        bookingsToUpdate = response.data.bookings
          .map((booking) => getAllIndexes(filteredUsers, booking.user_id))
          .flat();
      }

      plannerDispatcher.afterCreationBookingAssignment(bookingsToUpdate);

      projectIds.forEach((projectId) => {
        Api.Projects.get(projectId).then((response) => {
          setProjects(updateValueWithId(projectId, projects, response.data));
        });
      });

      setRepetitionQuestionDialogOpened(false);
    });
  };

  return (
    <TeambookDialog
      open={open}
      onClose={handleClose}
      title={t("update")}
      withCloseButton
      content={<p style={{marginBottom: 0}}>{t("planning.update_all_repetitions")}</p>}
      actionButtons={[
        {text: t("no"), onClick: handleNo, id: "repetitionNo", type: "outlined" },
        {text: t("yes"), onClick: handleYes, id: "repetitionYes" },
      ]}
    />
  );
};

RepetitionEditQuestionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setRepetitionQuestionDialogOpened: PropTypes.func.isRequired,
  setBookings: PropTypes.func.isRequired,
  closeEditWindow: PropTypes.func.isRequired,
  editingData: PropTypes.object.isRequired,
  setProjects: PropTypes.func.isRequired,
  plannerDispatcher: PropTypes.object.isRequired,
  projects: PropTypes.array.isRequired,
  filteredUsers: PropTypes.array.isRequired,
}

export default RepetitionEditQuestionDialog;
